import template from './ko-field-input-address.html';

class AddressInputComponentVM
{
	constructor(params)
	{
		this.params = params;

		this.readonly = ko.observable();
		this.name = ko.observable(params.name);
		this.label = ko.observable(params.label);
		this.$input = params.$input;
		this.help_text = ko.observable(params.help_text);
	}
}


export default {
	name: 'ko-field-input-address',
	viewModel: AddressInputComponentVM,
	module_type: 'ko',
	template: template
}
